export default {

    headingContainer: {
        margin: '50px 5px 50px 200px'
    },
    mainHeading: {
        marginTop: "20px",
        width: "80%",
        textAlign: "center",
        marginBottom: '25px',
        fontSize: '25px',
        fontWeight: 'bold',
        color: '#333'
    },
    subHeading: {
        marginTop: "20px",
        width: "80%",
        textAlign: "center",
        marginBottom: '20px',
        fontSize: '20px',
        fontWeight: 'bold',
        color: '#333'
    },
    basicCardContainer: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: '20px'
    },
    marginRight: {
        marginRight: '10px'
    },
    buttonsMargin: {
        margin: '15px'
    },

    arrowContainer: {
        color: 'blue',
        fontSize: '20px',
        marginRight: '1px'
    },

    arrowIcon: {
        width: '50px',
        height: '50px',
        color: 'blue',
        margin: '22px 4px 15px 64px'
    },
    rightArrowIcon: {
        width: '50px',
        height: '50px',
        color: 'blue',
        marginRight: '10px'
    },

    buttonPosition: {
        position: 'relative'
    },

    buttonsCardContainer: {
        width: '720px',
        height: '420px',
        padding: '10px',
        backgroundColor: '#EAEEE9',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '30px 112px 30px 100px'
    },

    tax1099Icon: {
        margin: '15px 23px 11px -80px'
    },

    labelStyle1: {
        fontSize: '16px',
        fontWeight: 'bold',
        marginRight: '5px',
    },

    labelStyle2: {
        fontSize: '14px',
        fontStyle: 'italic',
        marginRight: '5px',
    },
    paddingCard: {
        padding: '20px'
    },
    cardContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: '20px'
    },
    dropdownWidth: {
        width: '200px',
    },
    dropdownsContent: {
        marginBottom: '20px',
    },
    dropdownContainer: {
        display: "flex",
        flexDirection: "column",
        padding: "0 0 0 185px"
    },
    dropdownTy: {
        marginBottom: "20px"
    },
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginBottom: '20px',
    },
    cardContainer: {
        width: '100%',
        marginBottom: '20px',
    },
    card: {
        padding: '40px',
        boxSizing: 'border-box',
        border: '1px solid #ddd',
        borderRadius: '8px',
        backgroundColor: '#fff',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    },
    uploadCard: {
        padding: '40px',
        boxSizing: 'border-box',
        textAlign: 'center',
        border: '1px solid #ddd',
        borderRadius: '8px',
        backgroundColor: '#fff',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    },
    dropdownContainer: {
        marginTop: '20px',
    },
    dropdown: {
        marginBottom: '20px',
    },
    uploadContainer: {
        marginTop: '20px',
    },
    uploadSuccessMessage: {
        color: 'green',
        marginTop: '20px',
    },
    nextButton: {
        marginTop: '20px',
        width: 'initial',
        marginLeft: '775px'
    },
    attachmentItem: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '10px',
        margin: '5px 0',
        border: '1px solid #ccc',
        borderRadius: '5px',
        backgroundColor: '#f9f9f9',
        transition: 'background-color 0.3s',
    },
    fileName: {
        flex: 1,
        marginRight: '10px',
        fontSize: '14px',
        color: '#333',
    },
    removeButton: {
        backgroundColor: 'transparent',
        color: '#007bff',
        border: 'none',
        cursor: 'pointer',
        transition: 'color 0.3s',
    },
}